import '../stylesheets/news.css'
import * as d3 from 'd3'

import { Application } from '@hotwired/stimulus'
import NewspaperGraphController from '../controllers/news/newspaper_graph_controller'
import TopicGraphController from '../controllers/news/topic_graph_controller'
import DarkModeController from '../controllers/news/dark_mode_controller'
import TimeRangeController from '../controllers/news/time_range_controller'
import FavoriteController from '../controllers/news/favorite_controller'
import TopicInterestController from '../controllers/news/topic_interest_controller'

window.d3 = d3

const application = Application.start()
application.register('newspaper-graph', NewspaperGraphController)
application.register('topic-graph', TopicGraphController)
application.register('dark-mode', DarkModeController)
application.register('time-range', TimeRangeController)
application.register('favorite', FavoriteController)
application.register('topic-interest', TopicInterestController)
